import { AppBar, Box, Button, Toolbar } from "@material-ui/core";
import "./parkir-app-bar.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as WebesLogo } from "../../../assets/webes-logo.svg";
import { ReactComponent as TeljesLogo } from "../../../assets/teljes-logo.svg";
import { useWindowSize } from "../../../helpers/use-window-size";
import { IUserData } from "../../../web-services/models/user-data";
import * as AuthService from "../../../web-services/auth-service";
import { UserRole } from "../../../utilities/UserRole";
import { IParkirAppBarProps } from "./props";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function ParkirAppBar(props: IParkirAppBarProps)
{
    const [width, height] = useWindowSize();
    const [currentUser, setCurrentUser] = useState<IUserData | undefined>(undefined);
    const [currentRoles, setCurrentRoles] = useState<IUserData | undefined>(undefined);

    const navigate = useNavigate();

    useEffect(() =>
    {
        const user = AuthService.getCurrentUser();

        if (user)
        {
            setCurrentUser(user);
        }

    }, []);

    const isTest = process.env.REACT_APP_STAGE === "test" ;
    const renderWebesLogo = () =>
    {
        if (width > 500 && isTest)
        {
            return (<WebesLogo />);
        }

        return undefined;
    };
    const logOut = () =>
    {
        AuthService.logOut(navigate);
        setCurrentUser(undefined);
    };
    const hasParkingLotRole = currentUser?.roles.some(role => role.name === UserRole.ROLE_PARKINGLOT);
    const hasVJTRole = currentUser?.roles.some(role => role.name === UserRole.ROLE_VJT);
    const hasUserRole = currentUser?.roles.some(role => role.name === UserRole.ROLE_USER_CREATER);

    return (
        <AppBar className="parkir-app-bar">
            <Toolbar className="parkir-toolbar">
                <Box display="flex" flexGrow={1}>
                    { isTest && (<>
                        <TeljesLogo />
                    </>)}
                    {currentUser && (
                        <> {hasParkingLotRole && (
                            <>
                                <Button color="secondary" onClick={props.onOsszegzoButtonClick} > Összegző</Button>
                                <Button color="secondary" onClick={props.onTerkepButtonClick}>ParkingLot Térkép</Button>
                            </>)}
                            {hasVJTRole && (
                            <>
                                <Button color="secondary" onClick={props.onKijelzoTerkepButtonClick}>Kijelző Térkép</Button>
                                <Button color="secondary" onClick={props.onKijelzokButtonClick}>Kijelzők</Button>
                            </>)}
                        </>)}

                    {hasUserRole && <Button color="secondary" onClick={props.onFelhasznalokButtonClick}>Felhasználók</Button>}
                </Box>
                {currentUser && (
                    <><Button color="secondary" disabled onClick={props.onKijelzokButtonClick}>{currentUser?.name}</Button>
                        <Button color="secondary" onClick={logOut}>Kijelentkezés</Button>
                    </>)}
                {!currentUser && (<Button color="secondary" onClick={props.onLoginClick}>Bejelentkezés</Button>)}
                {renderWebesLogo()}
            </Toolbar>
        </AppBar>
    );
}

